import _ from 'lodash';

/**
 * Get data used by Events and Projects status
 * @param projectsOrEvents
 * @returns {{series: number[], labels: string[]}}
 */
export default function getStatusChartData(projectsOrEvents) {
  const counts = _.reduce(projectsOrEvents, (acc, project) => {
    if (project.completed) acc.completed++;
    else if (project.cancelled) acc.cancelled++;
    else if (project.active) acc.active++;
    else if (project.expired) acc.expired++;
    return acc;
  }, { completed: 0, cancelled: 0, active: 0, expired: 0 });

  const series = [
    counts.completed,
    counts.cancelled,
    counts.active,
    counts.expired
  ];

  const labels = [
    'Completed',
    'Canceled',
    'Active',
    'Expired'
  ];

  return { series, labels };
}
